import * as React from 'react';
import styled from 'styled-components';

const BecomeAnExpert = () => {
  React.useEffect(() => {
    const typeformScript = document.createElement('script');
    typeformScript.src = '//embed.typeform.com/next/embed.js';
    document.body.appendChild(typeformScript);
  }, []);

  return (
    <Root>
      <div data-tf-widget="xlGl3c4r" />
    </Root>
  );
};

export default BecomeAnExpert;

const Root = styled.div`
  > div {
    width: 100%;
    height: 100%;
    position: absolute;
  }
`;
